<template>
  <v-app>
    <div class="unsubscribe-wrapper" v-if="actionSuccess">
      <div class="survey-logo-client">
        <img :src="compData.logoUrl" />
      </div>

      <div v-if="actionSuccess == true">
        <div v-if="clientLanguage == 'nl'">
          <h2>U bent succesvol uitgeschreven</h2>
          <p>U zal niet lang deze mail van ons ontvangen.</p>
        </div>
        <div v-else>
          <h2>You have successfully unsubscribed</h2>
          <p>You will not receive any of these mails from us.</p>
        </div>
      </div>

      <div v-if="actionSuccess == false">
        <div v-if="clientLanguage == 'nl'">
          <h2>Er is iets fout gegaan</h2>
          <p>
            Het uitschrijven is niet gelukt. Probeer het later nog eens of neem
            contact op.
          </p>
        </div>
        <div v-else>
          <h2>Something went wrong</h2>
          <p>
            The unsubscribe did not work. Please try again later or contact us.
          </p>
        </div>
      </div>

      <!-- <div class="unsubscribe-footer">
        <a :href="compData.url">Contact</a>
      </div> -->
    </div>

    <div v-if="loading == true" class="response-loading">
      <div class="response-loading-icon">
        <v-progress-circular
          indeterminate
          color="primary"
          :size="50"
        ></v-progress-circular>
      </div>
    </div>
  </v-app>
</template>

<script>
import firebase from "firebase/compat/app";
import db from "../firebase/init";
import { log } from "util";

export default {
  name: "Unsubscribe",
  props: ["id"],
  data() {
    return {
      actionSuccess: null,
      clientId: null,
      compId: null,
      compData: {},
      loading: true,
      clientLanguage: "nl",
    };
  },

  created() {
    this.clientCheck();
  },

  methods: {
    clientCheck() {
      db.collection("surveys")
        .doc(this.id)
        .get()
        .then((doc) => {
          this.clientLanguage = doc.data().clientLanguage;
          this.clientId = doc.data().clientId;
          this.compId = doc.data().compId;
        })
        .then((company) => {
          db.collection("companies")
            .doc(this.compId)
            .get()
            .then((doc) => {
              this.compData = {};
              let companyData = doc.data();
              companyData.id = doc.id;
              this.compData = companyData;
            })
            .catch((error) => {
              console.error("Error getting comp data: ", error);
              this.actionSuccess = false;
              this.loading = false;
            });
        })
        .then(() => {
          var clientSubscriptionStatus = {};
          clientSubscriptionStatus[
            `companies.${this.compId}.unsubscribed`
          ] = true;

          db.collection("clients")
            .doc(this.clientId)
            .update(clientSubscriptionStatus);
        })
        .then(() => {
          this.actionSuccess = true;
          this.loading = false;
        })
        .catch((error) => {
          console.error("Bijwerken niet gelukt: ", error);
          this.actionSuccess = false;
          this.loading = false;
        });
    },
  },
};
</script>

<style>
.unsubscribe-wrapper {
  display: block;
  position: relative;
  width: calc(100% - 40px);
  max-width: 650px;
  padding: 20px 20px 10px 20px;
  margin: 20px auto;
  background: #ffffff;
  border: 1px solid #e8e9ee;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  overflow: hidden;
}
.unsubscribe-wrapper h2 {
  font-size: 24px;
  color: #111111;
  text-align: center;
  font-family: "Proxima nova", sans-serif;
  font-weight: 500;
  margin: 0;
  padding: 0;
}

.unsubscribe-wrapper p {
  font-family: "Proxima nova", sans-serif;
  color: #111111;
  text-align: center;
  padding: 10px 0;
  margin: 0;
  font-size: 14px;
}

.unsubscribe-footer {
  width: 100%;
  text-align: center;
}
.unsubscribe-footer a {
  text-decoration: none;
  font-family: "Proxima nova", sans-serif;
  color: rgba(0, 0, 0, 0.3);
  text-align: center;
  padding: 20px 0 10px 0;
  margin: 0;
  font-size: 14px;
}

.unsubscribe-footer a:hover {
  color: rgba(0, 0, 0, 0.8);
}

@media only screen and (max-width: 680px) {
  .unsubscribe-wrapper h2 {
    font-size: 20px;
  }
}
</style>
